import axios from "../utils/AxiosInstance";
import { ResponseMessage } from "../models/ResponseMessage";
import { Constants } from "../constants/constants";
import {
  MessageTemplate,
  MessageTemplateUpdateModel,
} from "../models/MessageModels";

const API_BASE_URL = Constants.API_BASE_URL;

export async function getMessageTemplatesByOrganizationAsync(
  token: string,
  organizationId: string,
): Promise<ResponseMessage<MessageTemplate[]>> {
  const response = await axios.get(
    `${API_BASE_URL}/messagetemplates/organization/${organizationId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return ResponseMessage.fromJson(response.data);
}

export async function createMessageTemplateAsync(
  token: string,
  template: MessageTemplate,
): Promise<ResponseMessage<MessageTemplate>> {
  const response = await axios.post(
    `${API_BASE_URL}/messagetemplates`,
    template,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return ResponseMessage.fromJson(response.data);
}

export async function updateMessageTemplateAsync(
  token: string,
  id: string,
  model: MessageTemplateUpdateModel,
): Promise<ResponseMessage<boolean>> {
  const response = await axios.put(
    `${API_BASE_URL}/messagetemplates/${id}`,
    model,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return ResponseMessage.fromJson(response.data);
}

export async function deleteMessageTemplateAsync(
  token: string,
  id: string,
): Promise<ResponseMessage<boolean>> {
  const response = await axios.delete(
    `${API_BASE_URL}/messagetemplates/${id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return ResponseMessage.fromJson(response.data);
}